/**
 * Editorial-dash template that creates a Question instance configured for
 * spectrum-style responses (strongly disagree to strongly agree).
 *
 * A creation-time preset registered in the `templates` config slot of the
 * new-space picker. Choosing this tile creates a Question instance with the
 * `commentslider` feature enabled; the slider UI itself lives in that feature,
 * not here. The template is purely the entry in the picker plus the feature
 * flags applied at create.
 */

import type { SpaceTemplate } from 'feature/editorial-dash/spaces';
import { t } from 'util/stdtypes';

export const CommentSliderTemplate: SpaceTemplate = {
    key: 'comment-slider',
    label: t('comment_slider_template.label', 'Comment Slider'),
    descriptionLabel: t(
        'comment_slider_template.description',
        'Ask users to respond to your question along a spectrum (e.g. “Strongly no” to “Strongly yes”).',
    ),
    imageUrl: 'images/comment-slider.svg',
    structureKey: 'question',
    featuresEnabled: ['commentslider'],
};
